export const stateMgr = {
	manager: {
		instance:null,
	},
};

export const actMgr = {
};

export const mutMgr= {
	manager_set_instance(state ,data){
		state.manager.instance = data;
	}
};

export const getMgr = {
	getManager: state => () => state.manager.instance,
};


// WEBPACK FOOTER //
// ./resources/assets/js/state/Manager.vuex.js